import { useCallback } from 'react';

import { useGetPatientEntitlementToMedicalServiceStatus } from '~libs.shared.patient-entitlement-to-medical-service';
import { VisitId } from '~libs.shared.visit';
import { isPatientEligibleForBenefit } from '~libs.shared.prescription';

import { DraftPrescriptionsFieldArray } from '../../DraftPrescriptionsForm.types';

type PatientEntitlementBenefitsCheckReturnFn = () => boolean;

export const usePatientEntitlementBenefitsCheck = (
   visitId: VisitId,
   draftPrescriptions: DraftPrescriptionsFieldArray
): PatientEntitlementBenefitsCheckReturnFn => {
   const patientEntitlementToMedicalServiceStatus = useGetPatientEntitlementToMedicalServiceStatus(visitId);

   return useCallback(() => {
      return !isPatientEligibleForBenefit(
         patientEntitlementToMedicalServiceStatus,
         draftPrescriptions.map((draftPrescription) => {
            return {
               // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
               reimbursement: draftPrescription.data.reimbursement!,
               additionalEntitlements: draftPrescription.data.additionalEntitlements,
            };
         })
      );
   }, [patientEntitlementToMedicalServiceStatus, draftPrescriptions]);
};
